import { i18n } from '@/locales';

const wordCount = {
  getMessage: function(field, {max}) {
    return i18n.tc('validation_max_words', max);
  },
  validate: function(value, {max}) {
    return value.trim().split(" ").length <= max;
  }
}

export default wordCount;
